export const TabName = Object.freeze({
  BEGINNER: 'beginner',
  ADVANCED: 'advanced'
})
